import dayjs from "dayjs";
import useTranslation from "utils/hooks/useTranslation";

const ColumnsTable = () => {
  const dateTimeFormat = "DD/MM/YYYY HH:mm";
  const checkEventTime = (eventTime) => (eventTime === "" || eventTime === undefined || eventTime === null ? "-" : `${dayjs.utc(eventTime).local().format(dateTimeFormat)}`);
  const checkData = (data) => (data === "" || data === undefined || data === null ? "-" : data);
  const STRUCTURE = useTranslation({ id: "structure" });
  const UNIT = useTranslation({ id: "unit" });
  const PLATE = useTranslation({ id: "plate" });
  const INBOUND_TRAILERS_PLATES = useTranslation({ id: "inbound_trailers_plates" });
  const OUTBOUND_TRAILERS_PLATES = useTranslation({ id: "outbound_trailers_plates" });
  const TRANSPORT_DOCUMENT = useTranslation({ id: "transport_document" });
  const CHECKIN_DATE = useTranslation({ id: "checkin_date" });
  const CHECKIN_SOURCE = useTranslation({ id: "checkin_source" });
  const RADIUS_IN_DATE = useTranslation({ id: "radius_in_date" });
  const RELEASED_VEHICLE = useTranslation({ id: "released_vehicle" });
  const CALLED_TO_LOBBY = useTranslation({ id: "called_to_lobby" });
  const RECORD_ENTRY = useTranslation({ id: "record_entry" });
  const CALLED_TO_DOCK = useTranslation({ id: "called_to_dock" });
  const FINISHED_OPERATION_TITLE = useTranslation({ id: "finished_operation_title" });
  const OUTBOUND_REGISTER = useTranslation({ id: "outbound_register" });
  const RAY_OUTPUT = useTranslation({ id: "ray_output" });
  const VEHICLE_FINALIZATION = useTranslation({ id: "vehicle_finalization" });
  return [
    {
      title: STRUCTURE,
      dataIndex: "structure",
      width: 150,
      key: "structure",
      render: (structure: string) => `${checkData(structure)}`,
    },
    {
      title: UNIT,
      dataIndex: "location",
      width: 150,
      key: "location",
      render: (location: string) => `${checkData(location)}`,
    },
    {
      title: PLATE,
      dataIndex: "vehiclePlate",
      width: 120,
      key: "vehiclePlate",
      render: (vehiclePlate: string) => `${checkData(vehiclePlate)}`,
    },
    {
      title: INBOUND_TRAILERS_PLATES,
      dataIndex: "inboundTrailersPlates",
      width: 200,
      key: "inboundTrailersPlates",
      render: (inboundTrailersPlates: string) => `${checkData(inboundTrailersPlates)}`,
    },
    {
      title: OUTBOUND_TRAILERS_PLATES,
      dataIndex: "outboundTrailersPlates",
      width: 200,
      key: "outboundTrailersPlates",
      render: (outboundTrailersPlates: string) => `${checkData(outboundTrailersPlates)}`,
    },
    {
      title: TRANSPORT_DOCUMENT,
      dataIndex: "dtDocument",
      width: 200,
      key: "dtDocument",
      render: (dtDocument: string) => `${checkData(dtDocument)}`,
    },
    {
      title: CHECKIN_DATE,
      dataIndex: "vehicleCheckinEventTime",
      width: 200,
      key: "vehicleCheckinEventTime",
      render: (vehicleCheckinEventTime: string) => checkEventTime(vehicleCheckinEventTime),
    },
    {
      title: CHECKIN_SOURCE,
      dataIndex: "checkinSource",
      width: 200,
      key: "checkinSource",
      render: (checkinSource: string) => checkData(checkinSource),
    },
    {
      title: RADIUS_IN_DATE,
      dataIndex: "radiusInEventTime",
      width: 200,
      key: "radiusInEventTime",
      render: (radiusInEventTime: string) => checkEventTime(radiusInEventTime),
    },
    {
      title: RELEASED_VEHICLE,
      dataIndex: "vehicleReleasedEventTime",
      width: 200,
      key: "vehicleReleasedEventTime",
      render: (vehicleReleasedEventTime: string) => checkEventTime(vehicleReleasedEventTime),
    },
    {
      title: CALLED_TO_LOBBY,
      dataIndex: "requestVehicleForGateEventTime",
      width: 200,
      key: "requestVehicleForGateEventTime",
      render: (requestVehicleForGateEventTime: string) => checkEventTime(requestVehicleForGateEventTime),
    },
    {
      title: RECORD_ENTRY,
      dataIndex: "inboundEventTime",
      width: 200,
      key: "inboundEventTime",
      render: (inboundEventTime: string) => checkEventTime(inboundEventTime),
    },
    {
      title: CALLED_TO_DOCK,
      dataIndex: "requestDockEntryEventTime",
      width: 200,
      key: "requestDockEntryEventTime",
      render: (requestDockEntryEventTime: string) => checkEventTime(requestDockEntryEventTime),
    },
    {
      title: FINISHED_OPERATION_TITLE,
      dataIndex: "finishedOperationEventTime",
      width: 200,
      key: "finishedOperationEventTime",
      render: (finishedOperationEventTime: string) => checkEventTime(finishedOperationEventTime),
    },
    {
      title: OUTBOUND_REGISTER,
      dataIndex: "outboundEventTime",
      width: 200,
      key: "outboundEventTime",
      render: (outboundEventTime: string) => checkEventTime(outboundEventTime),
    },
    {
      title: RAY_OUTPUT,
      dataIndex: "rangeOutboundEventTime",
      width: 200,
      key: "rangeOutboundEventTime",
      render: (rangeOutboundEventTime: string) => checkEventTime(rangeOutboundEventTime),
    },
    {
      title: VEHICLE_FINALIZATION,
      dataIndex: "canceledAt",
      width: 200,
      key: "canceledAt",
      render: (canceledAt: string) => checkEventTime(canceledAt),
    },
  ];
};

export default ColumnsTable;
